import { Directive } from '@angular/core';
import { UntypedFormControl, NG_VALIDATORS } from '@angular/forms';
@Directive({
    selector: '[SpaceValidator]',
    providers: [
        {
            provide: NG_VALIDATORS, useExisting: SpaceValidator, multi: true
        }
    ]
})
export class SpaceValidator {
    public static validate(formControl: UntypedFormControl): any {
        if (formControl.value) {
            return SpaceValidator.CheckValue(formControl);
        }
    }

    public static CheckValue(formControl: UntypedFormControl) {
        if (!/\S/.test(formControl.value)) {
            return { isSpace: true }
        }
        else {
            return null;
        }
    }

    validate(formControl: UntypedFormControl): { [key: string]: any } {
        return SpaceValidator.validate(formControl);
    }
}  